//Imports node_modules
import React, { useContext, useState, useEffect } from "react"
import Cookies from 'universal-cookie';

//Imports Css
import './PeCard.css'

//Imports Components

//Import Data
import { globalFunctions } from '../../../data/GlobalFunctions'
import { globalVariables } from "../../../data/GlobalVariables"

//Este Botão foi principlamente feito para evitar duplo click, detetar micro deslizes de dedos, touch and click events
const PeCard = (params) => {

    //--- Variaveis
    const {
        advancedClick,
    } = useContext(globalFunctions);

    const {
        isInsertingGlobal,
        isEdetingGlobalUpdate,
    } = useContext(globalVariables)

    const [isSelected, setIsSelected] = useState(false)
    const cookies = new Cookies();

    function setSelectedCard(selectedPe) {
        if (!params.pe.eEquipa && isInsertingGlobal) {
            setIsSelected(!isSelected)
        }
        if (!params.pe.eEquipa && isEdetingGlobalUpdate) {
            setIsSelected(!isSelected)
        }
        params.onClick(selectedPe)
    }

    //Sempre que ele carrega no botão de cancelar na userPage, ele actualiza o params.selectedMembers que eu uso para atutozar o estado
    useEffect(() => {
        setIsSelected(false)
    }, [params.pe]);


    useEffect(() =>{
        if(params.autoClick && params.pe.eEquipa){
            params.onClick(params.pe)
        }
    }, [params.autoClick]);
    
    useEffect(() => {
        //Mete borda verde em todos os pe que já estavam no grupo
        if(params.isEdeting){

            var groupMenbers = JSON.parse(localStorage.getItem('storedGroupMembers'));

            var found = false

            Object.keys(groupMenbers).forEach(function (groupMenber, indexGroupMenber) {
                if (groupMenbers[indexGroupMenber].npe === params.pe.npe && groupMenbers[indexGroupMenber].nmpe.trim() === params.pe.nmpe.trim()) {
                    found = true 
                }
            });

            if(found){
                setIsSelected(true)
            }else{
                setIsSelected(false)
            }
        }
        // eslint-disable-next-line
    }, [params.pe])

    function removeGroup() {
        params.delete()
    }

    function renderLayout() {
        if (params.pe.eEquipa) {
            return (
                <div>
                    <div className="wrapper">
                        <div className="mainCard">
                            <div className="mainInfo">
                                <div className="groupImg">
                                    <i className="fa fa-users"></i>
                                </div>
                                <div className="groupName">{"[" + params.pe.npe + "] " + params.pe.nmpe}</div>
                                <div className="groupStatus">{localStorage.getItem('storedGroupMembers') ? 'Estado: Criada' : 'Estado: Vazia'}</div>
                                <div className="groupDivider"></div>
                                <div className="Button">
                                    <button className="groupButton" onClick={e => setSelectedCard(params.pe)}>{localStorage.getItem('storedGroupMembers') ? 'Seleccionar' : 'Criar'}</button>
                                </div>
                            </div>
                            <div className="groupTableWrapper">
                                <div className="groupTable" >
                                        <div className='flexLayoutScrollable' style={{ marginTop: '14px', height: '300px'}}>
                                            {localStorage.getItem('storedGroupMembers') ?
                                                <div className="table-responsive" style={{ width: '82%' }}>
                                                    <table className="table-nowrap table">
                                                        <thead>
                                                            <tr>
                                                                <th style={{ width: '70px' }}>Nº.</th>
                                                                <th>Nome</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {JSON.parse(localStorage.getItem('storedGroupMembers')).map((member, index) =>
                                                                <tr key={member.npe}>
                                                                    <td>{member.npe}</td>
                                                                    <td>{member.nmpe}</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div> : <div></div>}
                                        </div>
                                    <div className="action-buttons">
                                        {localStorage.getItem('storedGroupMembers') ? <button className="edit" onClick={e => removeGroup()}><i className="fa fa-trash" ></i></button> : false}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div className="col-md-3 col-sm-3">
                    <div className={'card-container manual-flip'}>
                        <div
                            className="cardMenber"
                            onClick={e => advancedClick(e, (e => setSelectedCard(params.pe)))}
                            onTouchStart={e => advancedClick(e, (e => setSelectedCard(params.pe)))}
                            onTouchEnd={e => advancedClick(e, (e => setSelectedCard(params.pe)))}
                            onMouseDown={e => advancedClick(e, (e => setSelectedCard(params.pe)))}
                            onMouseUp={e => advancedClick(e, (e => setSelectedCard(params.pe)))}
                        >
                            <div className="front" style={isSelected && (params.isInserting || params.isEdeting) ? { border: '8px solid #79AB4B', borderRadius: '6px' } : {}} >
                                <div className="cover" style={params.pe.xCount > 0 ? { background: '#E77469' } : { background: '#41708C' }}></div>
                                <div className="branded" style={{ color: '#4C4C4D' }}>
                                    <span className='fa fa-user'></span>
                                </div>
                                <div className="content">
                                    <div className="main">
                                        <h2 className="use-for" style={{ color: '#4C4C4D', marginTop: '0px' }}>{"[" + params.pe.npe + "] " + params.pe.nmpe}</h2>
                                    </div>
                                </div>
                            </div>

                            {/* Ele precisa desta secção pois o original permitia virar a card, como limpei o conteudo tenho que meter uma largura minima*/}
                            <div className="back">
                                <div className="header">
                                </div>
                                <div className="content">
                                    <div style={{ minWidth: '190px', }}></div>
                                </div>
                                <div className="footer">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }

    return (
        <div key={params.pe.npe} >
            {renderLayout()}
        </div>
    )
}

export default PeCard